import { Dialog } from "primereact/dialog";
import { AgGridReact } from "@ag-grid-community/react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { SkeletonDataTable } from "../Loader/Loader";
import { useTaptik } from '../../Hooks/Features/employeeDashboard/useTaptik';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { convertTo12HourFormat } from "../../utils/Helper";

const TaptikHistory = ({ showHistory, setShowHistory, userId, showTaptik }) => {
    const { taptikData, setTaptikData, upsertTaptik, loader, showConfirmation, setShowConfirmation, reasonList, remark, setRemark, sendRemark, colDef, rowData, hoveredRange, setHoveredRange, getTaptikDetails, gridLoader, isDateChange, setIsDateChange, breakDetails, setBreakDetails } = useTaptik({ userId, fromTaptik: false });
    return (
        <div>
            <Dialog visible={showHistory} onHide={() => { setShowHistory(false); setHoveredRange([new DateObject(), new DateObject()]); }} draggable={false} header="TapTik" className={`modal-large w65 ${showTaptik ? "taptik-dialog" : ""}`} style={{ width: showTaptik ? "90vw" : "65vw", maxWidth: showTaptik ? "90vw" : "65vw" }}>
                <div className="d-flex gap-2 w100 h-100">
                    {showTaptik ?
                        <div className="taptik-container bg-white p-2 rounded w25">
                            <div className="d-flex justify-content-evenly mt-1 bg-light p-2 rounded">
                                <label className="d-flex align-items-center">
                                    <input
                                        type="radio"
                                        name="inOffice"
                                        value="false"
                                        checked={taptikData.inOffice === "no"}
                                        onChange={(e) => {
                                            setTaptikData((prev) => ({ ...prev, inOffice: "no" }));
                                        }}
                                        disabled={taptikData?.disabled}
                                    />
                                    Outdoor/WFH
                                </label>
                                <label className="d-flex align-items-center">
                                    <input
                                        type="radio"
                                        name="inOffice"
                                        value="true"
                                        checked={taptikData.inOffice === "yes"}
                                        onChange={(e) => {
                                            setTaptikData((prev) => ({ ...prev, inOffice: "yes" }));

                                        }}
                                        disabled={taptikData?.disabled}
                                    />
                                    In Office
                                </label>
                            </div>
                            <div className="mt-3 bg-light rounded p-2">
                                <div className="d-flex justify-content-between align-items-center py-1 px-2">
                                    Tap In:
                                    <span className="fw-bold"> {taptikData?.first ? taptikData?.first : " --:--"}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-1 px-2">
                                    Last Break In:
                                    <span className="fw-bold"> {taptikData?.lastBreak?.break_in ? taptikData?.lastBreak?.break_in : " --:--"}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center pb-2 pt-1 px-2">
                                    Last Break Out:
                                    <span className="fw-bold"> {taptikData?.lastBreak?.break_out ? taptikData?.lastBreak?.break_out : " --:--"}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center pb-1 pt-2 px-2" style={{ borderTop: " 1px dashed lightgrey" }}>
                                    Tap Out:
                                    <span className="fw-bold"> {taptikData?.last ? taptikData?.last : " --:--"}</span>
                                </div>
                            </div>
                            <button className={`w100 mt-3 rounded  ${taptikData?.first && "lunch-btn"}`} onClick={() => upsertTaptik("I")} disabled={taptikData?.first} style={{ background: "#14A44D" }} >
                                {loader?.I ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div> : <><FontAwesomeIcon icon="fa-solid fa-right-from-bracket" /> Tap In</>
                                }
                            </button>
                            <button className={`w100 mt-2 rounded  ${((taptikData?.lastBreak?.break_in && !taptikData?.lastBreak?.break_out) || taptikData?.last) && "lunch-btn"}`} style={{ background: "#0d6efd" }} disabled={(taptikData?.lastBreak?.break_in && !taptikData?.lastBreak?.break_out) || taptikData?.last} onClick={() => upsertTaptik("BI")}>
                                {loader?.BI ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div> : <> Break In</>
                                }
                            </button>
                            <button className={`w100 mt-2 rounded  ${(!taptikData?.lastBreak?.break_in || taptikData?.lastBreak?.break_out || taptikData?.last) && "lunch-btn"}`} style={{ background: "#0d6efd" }} disabled={!taptikData?.lastBreak?.break_in || taptikData?.lastBreak?.break_out || taptikData?.last} onClick={() => upsertTaptik("BO")}>
                                {loader?.BO ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div> : <>Break Out</>
                                }
                            </button>
                            <button className={`w100 mt-2 rounded ${(!taptikData?.first || taptikData?.last) && "lunch-btn"}`} onClick={() => upsertTaptik("O")} style={{ background: "#DC4C64" }} disabled={!taptikData?.first || taptikData?.last}>
                                {loader?.O ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span>
                                    </div> : <><FontAwesomeIcon icon="fa-solid fa-right-to-bracket" /> Tap Out</>
                                }
                            </button>
                        </div> : <></>
                    }
                    <div className={`${showTaptik ? "w75 p-2" : "w100"} taptik-container bg-white rounded`}>
                        <div>
                            <DatePicker portal zIndex={99999} value={hoveredRange} onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setHoveredRange(e); setIsDateChange(true);
                                            }
                                        }} onClose={() => { if (isDateChange) { getTaptikDetails(); setIsDateChange(false); } }} placeholder="Select Date Range" range rangeHover />
                        </div>
                        <div style={{ height: "50vh" }} className="ag-theme-alpine mt-2">
                            {gridLoader ? <SkeletonDataTable numSkeletons={12} numColumns={3} /> :
                                <AgGridReact rowData={rowData} columnDefs={colDef} rowHeight={30} />
                            }
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showConfirmation?.visible} onHide={() => { if (!showConfirmation?.ask_reason) { setShowConfirmation((prev) => ({ ...prev, visible: false, type: "", ask_reason: false })) } }} draggable={false} className="modal-xsmall">
                <div className="">
                    <div className="text-center fs-6 fw-bold">{showConfirmation?.type === "I" ? "You have tapped in late than your shift!" : "You have tapped out early than your shift!"}</div>
                    {showConfirmation?.ask_reason ?
                        <div>
                            <div className="mt-2">
                                <Dropdown value={remark?.selected} onChange={(e) => setRemark((prev) => ({ ...prev, selected: e.target?.value }))} placeholder="Select Reason" options={reasonList} optionLabel="reasons" filter filterInputAutoFocus className=" input-dd" />
                            </div>
                            {remark?.selected?.reason_type_key === "other" &&
                                <div className='mt-2'>
                                    <input placeholder='Write the unpunctuality remark' value={remark?.entered || ""} onChange={(e) => setRemark((prev) => ({ ...prev, entered: e.target?.value }))} className="w100 input-dd" />
                                </div>
                            }
                            <div className="text-right mt-2">
                                <button onClick={() => sendRemark()}>Submit</button>
                            </div>
                        </div> : ""
                    }
                </div>
            </Dialog>

            <Dialog visible={breakDetails?.visible} onHide={() => setBreakDetails((prev) => ({ ...prev, visible: false, data: [], date: null }))} className="modal-xsmall" style={{ width: "10%" }} draggable={false} header={`Break Details - ${breakDetails?.date}`}>
                <div style={{ maxHeight: "50vh", overflowY: "auto", overflowX: "hidden" }}>
                    <table>
                        <thead>
                            <tr>
                                <th className="border">In Time</th>
                                <th className="border">Out Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {breakDetails?.data?.map((br, index) => (
                                <tr key={index}>
                                    <td className="border">{convertTo12HourFormat(br?.break_in)}</td>
                                    <td className="border">{convertTo12HourFormat(br?.break_out)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Dialog>
        </div>
    )
}

export default TaptikHistory